module.exports = __webpack_public_path__ + "img/1.5d066923.png";